import { type SnakeToCamelCaseNested } from "../../types/utility-types/notation-utility.types";
import { camelToSnakeCase, snakeToCamelCase } from "../string";

export const transformObjectDeep = <T>(
  object: T,
  keyValueTransformer: any,
  objectPreProcessor?: (object: any) => any
): any => {
  if (objectPreProcessor && typeof objectPreProcessor === "function") {
    object = objectPreProcessor(object);
  }

  if (Array.isArray(object)) {
    return object.map((obj: any): any => transformObjectDeep(obj, keyValueTransformer, objectPreProcessor));
  } else if (object === null || typeof object !== "object") {
    return object;
  }

  return Object.fromEntries(
    Object.entries(object).map(([key, value]: any) =>
      keyValueTransformer(key, transformObjectDeep(value, keyValueTransformer, objectPreProcessor))
    )
  );
};

export const keysToCamelCase = <T>(object: T): SnakeToCamelCaseNested<T> =>
  transformObjectDeep(object, (key: any, value: any) => [snakeToCamelCase(key), value]);

export const keysToSnakeCase = <T>(object: T) =>
  transformObjectDeep(object, (key: any, value: any) => [camelToSnakeCase(key), value]);

export const groupBy = <T>(items: T[], groupCallback: (item: T) => string): Record<string, T[]> => {
  return items.reduce<Record<string, T[]>>((acc, item) => {
    const key = groupCallback(item);
    if (!acc[key]) {
      acc[key] = [];
    }
    acc[key].push(item);
    return acc;
  }, {});
};
